import AppConfig from '../AppConfig'

import { Service } from './index'

declare global {
  interface Window {
    FS?: any
  }
}

interface FullStoryInstance {
  getCurrentSession(): string
}

const fullstory: Service<FullStoryInstance> = {
  async init() {
    if (!AppConfig.FULL_STORY_ORG) {
      return
    }

    // Note: The main fullstory script is loaded via segment.

    /* eslint-disable */
    ;(function (w, d, s) {
      let a = d.getElementsByTagName('head')[0]
      let r = d.createElement('script')
      // @ts-expect-error
      r.async = 1
      r.src = s
      r.setAttribute('id', 'usetifulScript')
      r.dataset.orgId = AppConfig.FULL_STORY_ORG

      r.dataset.apiHostname = 'https://guides.fullstory.com'
      // @ts-expect-error
      a.appendChild(r)
    })(window, document, 'https://guides.fullstory.com/dist/gs.js')
    /* eslint-enable */
  },
  loaded() {
    return window.FS !== undefined
  },
  instance() {
    return window.FS
  },
}
export default fullstory
